type OwnProps = {
  id?: string;
  title?: string;
  details?: string;
};

const defaultProps: Partial<OwnProps> = {
  title: undefined,
  details: undefined,
};

type Props = OwnProps & typeof defaultProps;

function Hint({ title, details, id }: Props) {
  return (
    <span className="hint" id={id} data-testid={id}>
      <p>{title}</p>
      {details ? <small>{details}</small> : null}
    </span>
  );
}

Hint.defaultProps = defaultProps;

export default Hint;
